export class IssueType {
    constructor(obj) {
        this.IssueType_ID = obj.IssueType_ID;
        this.IssueTitle = obj.IssueTitle;
        this.Actions = obj.Actions;
    }
}
